<template>
  <div class="col-lg-12 control-section">
    <div id="MeasureObjTree" class="tree-control-wrapper" v-show="treeShow">
      <ejs-treeview id='MeasureObjTreeForCreate' ref='MeasureObjTreeForCreate' :fields='fields' :showCheckBox='true'></ejs-treeview>
    </div>
    <div id="tips" class="tree-control-wrapper" v-show="tipsShow" style="text-align:center; line-height:220px">
      {{this.text}}
    </div>
  </div>
</template>

<script>
import commonUtil from '../RealTimeTask/commonUtil';

export default {
  name: 'MeasureTreeForCreate',
  props: [
    'measureObjTreeShowType',
    'addOrModifyTaskFlag'
  ],
  data() {
    return {
      fields: {
        dataSource: [{ children: [] }],
        id: 'id',
        text: 'text',
        child: 'children',
        expanded: 'state'
      },
      treeShow: false,
      tipsShow: true,
      text: this.$t('Pm.selectResourcePlease')
    };
  },
  methods: {
    init() {
      this.$refs.MeasureObjTreeForCreate.uncheckAll();
    },

    getMeasureObjectTree(neType) {
      const params = {
        metertimeperiod: 2,
        neTypeId: neType
      }
      this.$axios.get(`/lte/pm/measuretaskmanagement/getMeasureObjectTree.html${commonUtil.analyticParameter(params)}`).then((response) => {
        this.fields = {
          dataSource: response.data,
          id: 'id',
          text: 'text',
          child: 'children',
          expanded: 'state'
        };
      });
    }
  },
  watch: {
    'measureObjTreeShowType': function (msg) {
      if (msg == 1) {
        this.getMeasureObjectTree(this.$parent.$refs.NeTreeForCreate.neTypeId);
        this.tipsShow = false;
        this.treeShow = true;
      } else if (msg == 2) {
        this.tipsShow = true;
        this.treeShow = false;
        this.text = this.$t('Pm.selectResourcePlease');
      } else if (msg == 3) {
        this.tipsShow = true;
        this.treeShow = false;
        this.text = this.$t('Pm.resourceOffline');
      } else if (msg == 4) {
        this.tipsShow = true;
        this.treeShow = false;
        this.text = this.$t('Pm.taskAlreadyExists');
      }
    }
  }
};
</script>

<style>

</style>
